// =============================================================================
// isAdminUser / isSuperAdminUser — checks admin partagés front + API routes.
// - isAdminUser  : rôle ADMIN/SUPER_ADMIN (JWT Fastify/NextAuth) OU groupe
//   Authentik admin, peu importe la casse/le format.
// - isSuperAdminUser : rôle SUPER_ADMIN (hérité) OU groupe amiral-admin —
//   réservé à /admin (Roadmap OS, Docs) et /admin/iam (IAM Control Plane).
//   La règle par courriel a été retirée le 23 septembre 2026 : un courriel se
//   change, un groupe s'administre dans Authentik (IDENTITY-AUTHENTIK.md §4).
// =============================================================================

const ADMIN_GROUPS = new Set(['admin', 'admins', 'amiral-admin', 'amiral_admins', 'authentik admins'])
// Groupes Authentik qui ouvrent les écrans réservés au propriétaire.
const SUPER_ADMIN_GROUPS = new Set(['amiral-admin'])

export function isSuperAdminUser(user?: { role?: string | null; groups?: string[] | null } | null): boolean {
  if (!user) return false
  // SUPER_ADMIN : rôle hérité des sessions déjà ouvertes — conservé pour ne
  // déconnecter personne au déploiement.
  if ((user.role ?? '').toUpperCase() === 'SUPER_ADMIN') return true
  return (user.groups ?? []).some(g => SUPER_ADMIN_GROUPS.has(g.toLowerCase().trim()))
}

export function isAdminUser(user?: { role?: string | null; groups?: string[] | null; email?: string | null } | null): boolean {
  if (!user) return false
  if (isSuperAdminUser(user)) return true
  const role = (user.role ?? '').toUpperCase()
  if (role === 'ADMIN' || role === 'SUPER_ADMIN') return true
  return (user.groups ?? []).some(g => ADMIN_GROUPS.has(g.toLowerCase().trim()))
}
